<template>
	<div>
		<div class="title-container">
			<div class="title">{{ newToken ? 'Token Created' : 'Create Token' }}</div>
			<div class="buttons">
				<router-link :to="{ name: 'tokens-page', params: $route.params }" exact class="button"><div class="hover-title">{{ newToken ? 'Exit Page' : 'Cancel' }}</div><span class="fa fa-times"></span></router-link>
			</div>
		</div>

		<form v-if="!newToken" ref="form" method="post" @submit.prevent="onSubmit">
			<form-errors :errors="errors"></form-errors>

			<field-errors v-if="submitAttempted" :form="$v.form" field="name"></field-errors>
			<div class="input-container">
				<div class="input-title">Token Name</div>
				<div class="input-box"><input v-model="form.name" type="text"></div>
			</div>

			<field-errors v-if="submitAttempted" :form="$v.form" field="tokens"></field-errors>

			<!-- TODO: Specify color. Have a 'custom' option that displays the color picker too. -->
<!--			<field-errors v-if="submitAttempted" :form="$v.form" field="color"></field-errors>-->
<!--			<div class="input-container">-->
<!--				<div class="input-title">Color</div>-->
<!--				<div class="input-box">-->
<!--					<selectize v-model="form.color" :settings="{ create: false }">-->
<!--						<option value="good">Good</option>-->
<!--						<option value="bad">Bad</option>-->
<!--						<option value="neutral">Neutral</option>-->
<!--					</selectize>-->
<!--				</div>-->
<!--			</div>-->

			<submit-button :has-errors="hasErrors" :loading="formSaving" icon="fa-save" text="Create Token"></submit-button>
		</form>

		<div v-if="newToken" class="input-container">
			<div class="input-title">This is your new token</div>
			<div class="input-box"><input type="text" ref="token" @focus="onFocus" readonly :value="newToken"></div>
			<div class="input-static-text"><p class="bad-text">Please write this down as it will never be shown again.</p></div>
		</div>
	</div>
</template>

<script>

import FormMixin from '@/mixins/FormMixin';
import { required } from 'vuelidate/lib/validators';

export default {

	mixins: [FormMixin],

	name: 'TokensCreatePage',

	data() {
		return {
			form: {
				name: '',
			},
			newToken: null,
		};
	},

	validations: {
		form: {
			name: { required },
		},
	},

	methods: {

		onFocus($e) {
			$e.target.select();
		},

		async onSubmit() {
			this.submit(async () => {
				const { data } = await this.$api.post(`/tokens`, this.form);

				this.$store.dispatch('addToast', 'Token Created');
				// this.$router.back();

				this.newToken = data;

				this.$nextTick(() => {
					this.$refs.token.focus();
				});

			}, (e) => {
				this.$store.dispatch('errorToast', 'Unable to create token: ' + e.message);
			});
		},

	},

};

</script>
